// normalise pour la détection des colonnes CSV
export function normalize(str = '') {
  return str
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

// 09:00 -> 9h ; 13:30 -> 13h30
export function formatHour(t) {
  if (!t) return '';
  const m = String(t).match(/^(\d{1,2}):(\d{2})/);
  if (!m) return t;
  const h = parseInt(m[1], 10);
  const minutes = m[2];
  if (minutes === '00') return `${h}h`;
  return `${h}h${minutes}`;
}

export function formatKgFR(value) {
  const n = Number(value) || 0;
  return n.toFixed(2).replace('.', ',');
}

//calcul en fonction des chargements
export function normalizeText(str = '') {
  return String(str)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
